import { render, staticRenderFns } from "./UserConfiguration.vue?vue&type=template&id=c18d1060"
import script from "./UserConfiguration.vue?vue&type=script&lang=js"
export * from "./UserConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports